import React from 'react';
import { ChatQuota } from 'modules/chat/domain/interfaces';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';

interface ChatQuotaBarProps {
  quota?: ChatQuota;
}

const ChatQuotaBar: React.FC<ChatQuotaBarProps> = ({ quota }) => {
  if (!quota) {
    return null;
  }

  return (
    <UDText type="caption-1" color={theme.colors.Gray}>
      {`Потрачено токенов: ${quota.totalSpentTokens} · Осталось: ${quota.remainingTokens} (${quota.period})`}
    </UDText>
  );
};

export default React.memo(ChatQuotaBar);
